import { render, staticRenderFns } from "./VTaskTags.vue?vue&type=template&id=068442e7&scoped=true"
import script from "./VTaskTags.vue?vue&type=script&lang=ts"
export * from "./VTaskTags.vue?vue&type=script&lang=ts"
import style0 from "./VTaskTags.vue?vue&type=style&index=0&id=068442e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068442e7",
  null
  
)

export default component.exports